import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { api } from "@/redux/api";
import { buildFacilityPath, getFacilityContext } from "@/utils/route-context";
import ContractList from "@/containers/contract/ContractList";

export default function FacilityContractPage() {
  const selectedFacilityId = useSelector((state) => state.Facility?.selected?.Id);
  const facilityContext = useSelector((state) => getFacilityContext(state));
  const { facilityId: routeFacilityId } = useParams();
  const facilityIds = useMemo(() => {
    const currentFacilityId = Number(routeFacilityId) || selectedFacilityId;
    return currentFacilityId ? [currentFacilityId] : [];
  }, [routeFacilityId, selectedFacilityId]);

  const loadRequests = useCallback(
    (selectedFacilityIds, params) => api.getContracts(selectedFacilityIds, params),
    []
  );
  const getDetailPath = useCallback(
    (record) => {
      return buildFacilityPath(`contract-request-detail/${record.id}`, facilityContext) || "/switch-view";
    },
    [facilityContext]
  );

  return (
    <ContractList
      facilityIds={facilityIds}
      loadRequests={loadRequests}
      getDetailPath={getDetailPath}
      showRequesterColumn
    />
  );
}
